import { PORTAL_LOCALSTORAGE_ACCESS_KEY } from '../constants/constant';

export const loadState = () => {
  try {
    let serializedState = localStorage.getItem(
      PORTAL_LOCALSTORAGE_ACCESS_KEY.state
    );
    if (serializedState === null) {
      return undefined;
    } else {
      return JSON.parse(serializedState);
    }
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    //Choose what we need to save in local storage to handle refresh
    let stateToSave = {
      isLoggedIn: state.isLoggedIn,
      session: state.session
    };
    let serializedState = JSON.stringify(stateToSave);
    localStorage.setItem(PORTAL_LOCALSTORAGE_ACCESS_KEY.state, serializedState);
  } catch (err) {}
};

export const reset = () => {
  try {
    localStorage.clear();
  } catch (err) {}
};

export const loadPersist = key => {
  try {
    let localPersistData = localStorage.getItem(
      PORTAL_LOCALSTORAGE_ACCESS_KEY.persist
    ); // getting persist key data as str from localstorage
    if (localPersistData !== null) {
      // if not null
      let data = JSON.parse(localPersistData); // data in JSON
      if (data.hasOwnProperty(key)) {
        // checkiing if passed key is in persist JSON
        return JSON.parse(data[`${key}`]);
      } else return undefined;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
};

export const setPersist = data => {
  try {
    let persistDataString = localStorage.getItem(
      PORTAL_LOCALSTORAGE_ACCESS_KEY.persist
    ); // persist data as string
    if (persistDataString !== null) {
      let persistDataJSON = JSON.parse(persistDataString); // if persist data exists, in JSON
      persistDataJSON[`${data.key}`] = JSON.stringify(data.value); // setting passed key with passed value
      let serializedState = JSON.stringify(persistDataJSON);
      localStorage.setItem(
        PORTAL_LOCALSTORAGE_ACCESS_KEY.persist,
        serializedState
      );
    }
  } catch (error) {}
};

export const loadFromLocalDB = key => {
  try {
    let localData = localStorage.getItem(key);
    if (localData !== null) {
      return JSON.parse(localData);
    } else return undefined;
  } catch (error) {
    return undefined;
  }
};

export const setInLocalDB = data => {
  let serializedState = JSON.stringify(data.value);
  localStorage.setItem(data.key, serializedState);
};

export const removeFromLocalStorage = key => {
  localStorage.removeItem(key);
};
